function usernameErrors () {
    const errors = []
    if (!this.$v.form.username.$dirty) return errors;
    !this.$v.form.username.required && errors.push('Introduzca su Usuario')
    return errors
}

function passwordErrors () {
    const errors = []
    if (!this.$v.form.password.$dirty) return errors;
    !this.$v.form.password.required && errors.push('Introduzca su Contraseña')
    return errors
}


export {
    usernameErrors,
    passwordErrors
}
